import * as gabito from './eventSenders/gabito';
import * as dataLayer from './eventSenders/dataLayer';
import logger from '@spotify-internal/node-logger';
import { getPublicRuntimeConfigValue } from '../config';
import { EventData } from '@spotify-internal/event-sender';

export enum Tracker {
  Gabito = 1,
  DataLayer = 2,
}

export type GabitoEventDefinition = {
  tracker: Tracker.Gabito;
  eventData: EventData;
  options?: {
    authorize?: boolean;
    flush?: boolean;
  };
};

export type DataLayerEventDefinition = {
  tracker: Tracker.DataLayer;
  eventData: object;
};

export type EventDefinition = GabitoEventDefinition | DataLayerEventDefinition;

const publishEnabled = getPublicRuntimeConfigValue<boolean>(
  'analytics.gabito.enabled',
);

export const trackEvent = (eventDefinitions: EventDefinition[]) => {
  return Promise.all(
    eventDefinitions.map(eventDefinition => {
      switch (eventDefinition.tracker) {
        case Tracker.Gabito:
          if (publishEnabled) {
            return gabito
              .getEventSender()
              .then(eventSender =>
                eventSender.send(
                  eventDefinition.eventData,
                  eventDefinition.options,
                ),
              );
          }

          return logger.info('Gabito event: ', eventDefinition.eventData);

        case Tracker.DataLayer:
          return dataLayer.getEventSender().log(eventDefinition.eventData);

        default:
          throw new Error(`Unknown tracker for event: ${eventDefinition}`);
      }
    }),
  );
};
